(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.stickyType = this.getAttribute('data-sticky-type') || 'none';
      this.headerIsAlwaysSticky =
        this.stickyType === 'always' ||
        this.stickyType === 'reduce-logo-size';
      // Hide-on-scroll fights vertical scrolling and causes jitter; keep header visible.
      this.enableScrollHide = true;
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky || this.stickyType === 'on-scroll-up') {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollTick = false;
      this.scrollDirection = 0;
      this.scrollDirectionDistance = 0;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.enableScrollHide) {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.createObserver();
      }
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (this.scrollTick) return;
      this.scrollTick = true;

      requestAnimationFrame(() => {
        this.scrollTick = false;
        this.handleScroll();
      });
    }

    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
if (document.body.style.overflow === 'hidden') return;

      const scrollDelta = scrollTop - this.currentScrollTop;
      this.currentScrollTop = scrollTop;

      if (Math.abs(scrollDelta) < 1) return;

      if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        this.scrollDirection = 0;
        this.scrollDirectionDistance = 0;
        this.reset();
        return;
      }

      if (scrollTop <= this.headerBounds.bottom) return;

      this.header.classList.add('scrolled-past-header');

      const direction = scrollDelta > 0 ? 1 : scrollDelta < 0 ? -1 : 0;
      if (direction !== this.scrollDirection) {
        this.scrollDirection = direction;
        this.scrollDirectionDistance = 0;
      }
      this.scrollDirectionDistance += Math.abs(scrollDelta);

      if (this.scrollDirectionDistance < 28) return;

      if (this.scrollDirection > 0) {
        if (this.preventHide) {
          this.scrollDirectionDistance = 0;
          return;
        }
        this.hide();
      } else if (this.scrollDirection < 0) {
        if (this.preventReveal) {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          this.hide();
          return;
        }

        this.reveal();
      }

      this.scrollDirectionDistance = 0;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.header.classList.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('animate', 'shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (!this.header.classList.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trusted-experts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // --- Video Modal Popup Logic ---
    const modal = document.querySelector('.trusted-experts-modal');
    const modalContent = modal?.querySelector('.trusted-experts-modal__content');
    const modalClose = modal?.querySelector('.trusted-experts-modal__close');
    const modalOverlay = modal?.querySelector('.trusted-experts-modal__overlay');
    const triggers = document.querySelectorAll('.trusted-experts-card__trigger');

    if (!modal || !modalContent) return;

    function extractVideoHtml(url) {
      if (!url) return '';
      
      // Youtube
      const ytReg = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/i;
      const ytMatch = url.match(ytReg);
      if (ytMatch && ytMatch[1]) {
        return `<iframe src="https://www.youtube.com/embed/${ytMatch[1]}?autoplay=1&rel=0&modestbranding=1" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen></iframe>`;
      }

      // Vimeo
      const vimeoReg = /vimeo\.com\/(?:video\/)?([0-9]+)/i;
      const vimeoMatch = url.match(vimeoReg);
      if (vimeoMatch && vimeoMatch[1]) {
        return `<iframe src="https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1&title=0&byline=0&portrait=0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>`;
      }

      // Direct video file (MP4, WebM, Ogg, MOV etc)
      if (url.match(/\.(mp4|webm|ogg|mov)/i) || url.includes('files/')) {
        return `<video src="${url}" controls autoplay playsinline></video>`;
      }

      // Fallback iframe
      return `<iframe src="${url}" allow="autoplay" allowfullscreen></iframe>`;
    }

    function openModal(url) {
      const html = extractVideoHtml(url);
      if (!html) return;
      
      modalContent.innerHTML = html;
      modal.classList.add('is-active');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      
      // Focus close button for accessibility
      setTimeout(() => modalClose?.focus(), 100);
    }

    function closeModal() {
      modal.classList.remove('is-active');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      
      // Clear contents to stop video playback immediately
      modalContent.innerHTML = '';
    }

    triggers.forEach(trigger => {
      trigger.addEventListener('click', function(e) {
        e.preventDefault();
        const url = this.getAttribute('data-video-url');
        if (url) {
          openModal(url);
        }
      });
    });

    modalClose?.addEventListener('click', closeModal);
    modalOverlay?.addEventListener('click', closeModal);
    
    // Close on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
